import { BaseItemTypes } from "@/components/dnd/ItemTypes";
import { AnalyticsV2ElementType, TagType } from "@/models/etc/types";
import { AnalyticsElementIdentity, AnalyticsElementKind, ParameterLink } from "@/models/interfaces/entity-settings/charts/charts";

/** Тип цели перемещения при DnD: корень сегмента, папка или табличный элемент (выборка/проекция/список). */
export type MoveTargetKind = 'root' | 'folder' | 'table';

export interface AnalyticsRequestData {
    // what i create or change; required fields
    id: number;
    type: BaseItemTypes;
    kind?: AnalyticsElementKind;
    newParentKind?: AnalyticsElementKind;
    destinationType?: AnalyticsV2ElementType;

    // if no - means projection
    sourceType?: AnalyticsV2ElementType;
    newParentId?: number;
    oldParentId?: number;
    newParentCombinedName: string;
    oldParentType?: BaseItemTypes;
    newParentType?: BaseItemTypes;
    // if no - means projection
    newParentSourceType?: AnalyticsV2ElementType;
    newParentDestinationType?: AnalyticsV2ElementType;
    newPosition?: number;
    oldPosition?: number;
    NewName?: string;

    reportIds?: number[];

    parentFolderId?: number;
    setFavorite?: boolean;

    /** Цель перемещения: 'root' = в корень сегмента, 'folder' = в папку, 'table' = к табличному элементу. */
    moveTargetKind?: MoveTargetKind;
    /** Id папки-цели (при moveTargetKind === 'folder'). */
    targetFolderId?: number;
    /** Сегмент папки-цели (при moveTargetKind === 'folder'). */
    targetSegment?: AnalyticsV2ElementType;
    /** Буквально корневой элемент (без родителя) — не путать с «корневая выборка по смыслу», см. комментарии в changeChildParent. */
    isRoot?: boolean;
    /** Тип родителя перетаскиваемого элемента (для проверки «корневая выборка по смыслу»). */
    parentType?: BaseItemTypes;
    /** FolderId перемещаемой папки (при type === FOLDER); для сборки AnalyticsFolderIdentity. */
    movedFolderId?: number;
}

export enum LockedEntityType {
    Default = 0,
    Bill = 1,
    StorageItem = 2
}

export enum EntityLockResultType {
    LockedByYou = 0,
    LockedByOther = 1,
    NotLocked = 2
}

export interface EntityLockResult {
    Type: EntityLockResultType;
    ExpiresAtUtc?: Date;
}

// some edit Asker classes
export interface MultiEditEntityContainer {
    EntityIds: number[];
    TakeAnything: boolean;
    Segment: AnalyticsV2ElementType;
    ElementIdentity?: AnalyticsElementIdentity;
}

export interface MultiEditTagAsker {
    Container: MultiEditEntityContainer;
    TagIds: number[];
}

export interface MultiEditTagStatusEditAsker {
    Container: MultiEditEntityContainer;
    NewStatus: TagType;
}

export interface MultiEditStorageNoteEditRequest {
    Container: MultiEditEntityContainer;
    Note: string;
    ActionType: MultiEditStorageNoteEditType;
    UsedNoteTemplateIds: number[];
    IssuedAt?: string | null;
}

export enum MultiEditStorageNoteEditType {
    // Добавить комментарий к имеющимся.
    Append = 0,
    // Заменить старые комментарии на новый.
    Rewrite = 1
}

export interface PinnedEntitiesSetRequest {
    Container: MultiEditEntityContainer;
}

export interface MultiEditTagAddAsker extends MultiEditTagAsker {        
    NewTags: string[];
}

export interface MultiEditEntityToListAddRequest {
    Container: MultiEditEntityContainer;
    ListId?: number;
    NewListName?: string;
}

export interface MultiEditEntityFromListRemoveRequest {
    Container: MultiEditEntityContainer;
}

export interface MultiEditParameterListAsker {
    Container: MultiEditEntityContainer;
    ParameterTemplateIds: number[];
}

export interface ParameterInstanceValue
{
    StringValue?: string; // Значение строкового типа.
    NumberValue?: number; // значение численных типов.
    BoolValue?: boolean; // значение логического типа.
    SelectedValueId?: number; // выбранное значений из набора.
    NewCreatedValue?: ValueOfSetContainer; // для открытых множеств, если было создано и выбрано новое значение.
    DateValue?: Date; // значение типа "Дата" 
}

export interface ValueOfSetContainer
{
    // Идентификатор значения. Для нового значения не устанавливать.
    Id: number;
    // Название значения типа "Строка".
    NameString: string;
    // Название значения типа "Целый / Дробный".
    NameNumber?: number;
    // Название значения типа "Дата".
    NameDate?: Date;
}

export interface MultiEditParameterValueEditAsker
{
    Container: MultiEditEntityContainer;
    ParameterLink: ParameterLink;
    InstanceValues: ParameterInstanceValue[];
}
